import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _DiagnosisHelp, _HealthScope, _HealthServiceProvision, _MeansAdministration, _PharmaCumState, _PharmaRecordState } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { HealthLOINCEditor } from "../../../../GestionTerceros/AbstractAccount/HealthLOINC/HealthLOINCEditor";
import { HealthAssesmentResultEditor } from "../../../../GestionTerceros/AbstractAccount/HealthAssesmentResult/HealthAssesmentResultEditor";

interface Props {
    idClinicalDocument: number;
    issueDate: any
}

export const DiagnosisHelp = ({ idClinicalDocument, issueDate }: Props) => {

    const diag = useDataBean(_DiagnosisHelp);
    const paginador = usePaginator();
    const [form, setForm] = useState<any>({
        IDHealthLOINC: null,
        LOINC_NUM: null,
        IDHealthAssesmentResult: null,
        HealthAssesmentResultName: null
    })
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcreate, setModalcreate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idClinicalDocument, issueDate, paginador.page])

    const getLista = () => {

        diag.instance.getHealthDiagnosisHelpCatalog(null, null, null, idClinicalDocument, issueDate, form.IDHealthLOINC, form.IDHealthAssesmentResult, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.Ass = (user.DataBeanProperties.HealthAssesmentResultCode ?? "") + "-" + (user.DataBeanProperties.HealthAssesmentResultName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const create = () => {
        diag.setBean({
            IDClinicalDocument: idClinicalDocument,
            IssueDate: issueDate
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        diag.instance.deleteVoid(diag.bean.IDHealthDiagnosisHelp).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const editaItem = () => {
        //console.log(entailment.bean);
        diag.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDHealthDiagnosisHelp', visible: true },
        { title: 'ID Evento Clínico', property: 'IDClinicalDocument', visible: true },
        { title: 'Fecha Evento Clínico', property: 'IssueDate', visible: true },
        { title: 'Paraclínico/Ayuda Diagnóstica', property: 'LOINC_NUM', visible: true },
        { title: 'Nombre Comun', property: 'LONG_COMMON_NAME', visible: true },
        { title: 'Nombre corto', property: 'SHORTNAME', visible: true },
        { title: 'Escala', property: 'SCALE_TYP', visible: true },
        { title: 'Observaciones Prueba', property: 'Description', visible: true },
        { title: 'Tipo de Resultado', property: 'Ass', visible: true },
        { title: 'Fecha de Resultado', property: 'AssessmentResultDate', visible: true },
        { title: 'Resultado', property: 'HealthAssesmentResultValue', visible: true },
        { title: 'Observación Resultado', property: 'HealthAssesmentStrValue', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    return (

        <div className="row">
            <div className="col-md-12">
                <label>Ayudas Diagnósticas</label>
            </div>
            <div className="col-md-4">
                <HealthLOINCEditor render={form.LOINC_NUM} idSelector={form.IDHealthLOINC} onChange={(e) => { setForm({ ...form, "IDHealthLOINC": e.IDHealthLOINC, "LOINC_NUM": e.Name }) }} returnType="Object" />
            </div>
            <div className="col-md-4">
                <HealthAssesmentResultEditor render={form.HealthAssesmentResultName} idSelector={form.IDHealthAssesmentResult} onChange={(e) => { setForm({ ...form, "IDHealthAssesmentResult": e.IDHealthAssesmentResult, "HealthAssesmentResultName": e.Name }) }} returnType="Object" />
            </div>
            <div className="col-md-4">
                <label>Búsqueda por Texto</label>
                <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
            </div>
            <div className="col-md-4 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={diag.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>

                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-6">
                            <HealthLOINCEditor render={diag.bean.LOINC_NUM} idSelector={diag.bean.IDHealthLOINC} onChange={(e) => { diag.setBean({ ...diag.bean, "IDHealthLOINC": e.IDHealthLOINC, "LOINC_NUM": e.Name }) }} returnType="Object" />
                        </div>
                        <div className="col-md-6">
                            <HealthAssesmentResultEditor render={diag.bean.HealthAssesmentResultName} idSelector={diag.bean.IDHealthAssesmentResult} onChange={(e) => { diag.setBean({ ...diag.bean, "IDHealthAssesmentResult": e.IDHealthAssesmentResult, "HealthAssesmentResultName": e.Name }) }} returnType="Object" />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={diag.bean.Description} onChange={diag.handleChange} />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {diag.bean.Name}</strong>
                </ModalConfirm>
            </div>

        </div>

    )
}